<template>
  <div class="row">
    <div class="col-sm-12">
        <div class="xcard">
        <b class="text-primary">Registros por fecha de inscripcion</b>
        <canvas id="chart-area6c"></canvas>
        </div>
    </div>
  </div> 
</template>
  
  <script> 
  import { getRandomPastelColor } from './colores'

  export default {
      data() {
        return { 
          grafico: null,
        };
      },
      methods: {
        async openmodal(data) {  
          const da = window.Object.assign([], data);
          const conteoIntereses = {};

          da.forEach(x => {
            x.xfecha = x.fecha_registro.split("T")[0];
            const nombreInteres = x.xfecha;
            if (conteoIntereses[nombreInteres]) {
              conteoIntereses[nombreInteres]++;
            } else {
              conteoIntereses[nombreInteres] = 1;
            } 
          }); 

        if(this.grafico){
            this.grafico.destroy();
        }
          setTimeout(() => {
            this.crearGraficoGeneral(conteoIntereses);
          }, 400);
        }, 
        crearGraficoGeneral(conteoIntereses){ 
            const labeles = Object.keys(conteoIntereses);
            const datas = Object.values(conteoIntereses);
            
            const colores = ["#cde7f7","#6695bd"];
            for (let i = 0; i < datas.length; i++) {
              colores.push(getRandomPastelColor());
            }

            const datosCombinados = datas.map((valor, index) => {
                return {
                    valor: valor,
                    label: labeles[index],
                    color: colores[index]
                };
            });

            datosCombinados.sort((a, b) => b.valor - a.valor);

            const datasOrdenadas = datosCombinados.map(item => item.valor);
            const labelesOrdenadas = datosCombinados.map(item => item.label);

            const config = {
                type: 'pie',
                data: {
                    datasets: [{ data: datasOrdenadas, backgroundColor: colores, label: 'Grafico General' }],
                    labels: labelesOrdenadas,
                },
                options: {
                    responsive: true, 
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItem, data) {  
                                var cant = data.datasets[0].data[tooltipItem.index] || '';
                                return cant;
                            },
                        },
                    },
                }, 
                plugins: [{
                    // Plugin para mostrar los labels dentro de las barras
                    afterDatasetsDraw: function(chart) {
                        var ctx = chart.ctx;
                        chart.data.datasets.forEach(function(dataset, i) {
                            var meta = chart.getDatasetMeta(i);
                            meta.data.forEach(function(bar, index) {
                              var data = dataset.data[index];

                              // Cálculo del ángulo medio del segmento
                              var startAngle = bar._model.startAngle;
                              var endAngle = bar._model.endAngle;
                              var midAngle = (startAngle + endAngle) / 2;

                              // Radio donde se colocará el texto (ajusta el valor para cambiar la distancia)
                              var radius = (bar._model.innerRadius + bar._model.outerRadius) / 2;

                              // Calcular la posición del texto usando trigonometría
                              var x = bar._model.x + Math.cos(midAngle) * radius;
                              var y = bar._model.y + Math.sin(midAngle) * radius;

                              ctx.fillStyle = '#000000'; 
                              ctx.textAlign = 'center';
                              ctx.textBaseline = 'middle';
                              ctx.fillText(data, x, y);
                            });
                        });
                    }
                }]
            }; 

            const idcanvas = "chart-area6c"
            var ctx1 = document.getElementById(idcanvas).getContext('2d');
            this.grafico = new window.Chart(ctx1, config);
        },
        
      },
    };
  </script>
  